import { LayoutConfig } from '../models/layout.interface';
import {
  MenuMode,
  ColorScheme,
  ComponentTheme,
  MenuTheme,
  TopbarTheme,
  MenuProfilePosition,
  InputStyle,
} from '../enums/layout';

import { ref } from 'vue';

const LAYOUT_CONFIG_KEY = 'layout_config';

export class LayoutService {
  private static instance: LayoutService;
  private defaultConfig: LayoutConfig = {
    menuMode: MenuMode.STATIC,
    colorScheme: ColorScheme.LIGHT,
    componentTheme: ComponentTheme.GREEN,
    scale: 14,
    menuTheme: MenuTheme.LIGHT,
    topbarTheme: TopbarTheme.INDIGO,
    menuProfilePosition: MenuProfilePosition.END,
    inputStyle: InputStyle.OUTLINED,
    ripple: false,
  };

  private constructor() {}

  public static getInstance(): LayoutService {
    if (!LayoutService.instance) {
      LayoutService.instance = new LayoutService();
    }
    return LayoutService.instance;
  }


  public loadConfig(userConfig?: string): LayoutConfig {

    if (userConfig) {
      try {
        const parsedConfig = JSON.parse(userConfig);



        if (!parsedConfig || typeof parsedConfig !== 'object') {

          return this.defaultConfig;
        }


        const mergedConfig: LayoutConfig = {
          ...this.defaultConfig,
          ...parsedConfig,
        };


        this.validateConfig(mergedConfig);


        return mergedConfig;
      } catch (e) {

        return this.defaultConfig;
      }
    }


    return this.defaultConfig;
  }


  private validateConfig(config: LayoutConfig): void {

    if (!Object.values(MenuMode).includes(config.menuMode as MenuMode)) {

      config.menuMode = this.defaultConfig.menuMode;
    }


    if (!Object.values(ColorScheme).includes(config.colorScheme as ColorScheme)) {

      config.colorScheme = this.defaultConfig.colorScheme;
    }

    if (!Object.values(ComponentTheme).includes(config.componentTheme as ComponentTheme)) {

      config.componentTheme = this.defaultConfig.componentTheme;
    }

    if (!Object.values(MenuTheme).includes(config.menuTheme as MenuTheme)) {

      config.menuTheme = this.defaultConfig.menuTheme;
    }

    if (!Object.values(TopbarTheme).includes(config.topbarTheme as TopbarTheme)) {

      config.topbarTheme = this.defaultConfig.topbarTheme;
    }

    if (!Object.values(MenuProfilePosition).includes(config.menuProfilePosition as MenuProfilePosition)) {

      config.menuProfilePosition = this.defaultConfig.menuProfilePosition;
    }

    if (!Object.values(InputStyle).includes(config.inputStyle as InputStyle)) {

      config.inputStyle = this.defaultConfig.inputStyle;
    }

    if (typeof config.scale !== 'number' || config.scale < 12 || config.scale > 16) {

      config.scale = this.defaultConfig.scale;
    }

    if (typeof config.ripple !== 'boolean') {

      config.ripple = this.defaultConfig.ripple;
    }
  }

  public saveConfig(config: LayoutConfig): void {
    // Validar la configuración antes de guardarla
    this.validateConfig(config);
    
    // Guardar en localStorage
    localStorage.setItem(LAYOUT_CONFIG_KEY, JSON.stringify(config));
    
    // Emitir un evento para que otros componentes puedan reaccionar al cambio
    const event = new CustomEvent('layout-config-updated', { detail: config });
    window.dispatchEvent(event);
  }

  public updateConfig(config: LayoutConfig): void {
    this.saveConfig(config);
  }

  // TODO: Implementar estos métodos cuando se tenga el backend
  public async fetchConfig(): Promise<LayoutConfig> {
    // const response = await fetch('/api/layout/config');
    // return response.json();
    return this.loadConfig();
  }

  public async updateConfigAPI(config: LayoutConfig): Promise<void> {
    // await fetch('/api/layout/config', {
    //   method: 'PUT',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(config)
    // });
    this.saveConfig(config);
  }
}
